// Test utility to check environment variables in the browser
// This will help debug why env vars aren't loading

export function testEnvironmentVariables() {
  console.group('🔍 Environment Variable Test');
  
  // Check if we're in browser
  if (typeof window === 'undefined') {
    console.log('Running in Node.js environment');
  } else {
    console.log('Running in browser environment');
  }
  
  // Check all REACT_APP_ variables
  const reactAppVars = Object.keys(process.env)
    .filter(key => key.startsWith('REACT_APP_'))
    .map(key => ({
      key,
      value: process.env[key],
      hasValue: !!process.env[key],
    }));
  
  console.log('Found REACT_APP_ variables:', reactAppVars.length);
  reactAppVars.forEach(({ key, value, hasValue }) => {
    if (hasValue) {
      const displayValue = key.includes('KEY') 
        ? `${value?.substring(0, 10)}...` 
        : value;
      console.log(`✅ ${key}: ${displayValue}`);
    } else {
      console.log(`❌ ${key}: NOT SET`);
    }
  });
  
  // Check specific EmailJS vars
  console.log('\nEmailJS Specific Variables:');
  const emailVars = {
    PUBLIC_KEY: process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
    SERVICE_ID: process.env.REACT_APP_EMAILJS_SERVICE_ID,
    TEMPLATE_ID: process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
    NOTIFICATION_EMAIL: process.env.REACT_APP_NOTIFICATION_EMAIL,
  };
  
  Object.entries(emailVars).forEach(([name, value]) => {
    console.log(`${name}:`, value ? `✅ SET (${value.substring(0, 15)}...)` : '❌ NOT SET');
  });
  
  console.groupEnd();
  
  return {
    allSet: Object.values(emailVars).every(v => !!v),
    vars: emailVars,
  };
}

// Make it available globally for easy testing
if (typeof window !== 'undefined') {
  (window as any).testEnv = testEnvironmentVariables;
}

